var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.data.uiTextVOs),function(item,index){return _c('div',{key:'textTool-sty'+item.id+index,staticClass:"textTool-sty",style:({
      width: item.posWidth * _vm.scale + 'vw',
      height: item.posHeight * _vm.scale + 'vw',
      transform: 'scale(' + _vm.scale + ')',
      position: 'absolute',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: !_vm.noRotation
        ? 'rotate(' + item.rotation + 'deg)'
        : 'rotate(0deg)',
    }),attrs:{"id":'t' + _vm.indexP + ',' + _vm.ind + ',' + index}},[_c('div',{staticClass:"text-con",style:({
        width: item.posWidth + 'vw',
        transform: 'scale(' + _vm.scale + ')',
        'word-wrap': 'break-word',
        'word-break': 'break-word',
        'transform-origin': 'left top 0',
      }),domProps:{"innerHTML":_vm._s(_vm.ToCDB(item.content))}})])}),_vm._l((_vm.data.uiImageVOs),function(item,index){return _c('div',{key:'imageTool-sty'+item.id+index,staticClass:"imageTool-sty",class:{ active: item.selected },style:({
      position: 'absolute',
      width: item.posWidth * _vm.scale + 'vw',
      height: item.posHeight * _vm.scale + 'vw',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: 'rotate(' + item.rotation + 'deg)',
    })},[_c('img',{style:({ width: '100%', height: '100%' }),attrs:{"src":_vm.aliOsUrl(item.src) +
        '?v=' +
        new Date().getTime() +
        Math.random()}})])}),_vm._l((_vm.data.uiModelVOs),function(item,index){return _c('div',{key:'modelTool-sty'+item.id+index,staticClass:"modelTool-sty",class:{ active: item.selected },style:({
      width: item.posWidth * _vm.scale + 'vw',
      height: item.posHeight * _vm.scale + 'vw',
      position: 'absolute',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: 'rotate(' + item.rotation + 'deg)',
    })},[_c('img',{staticClass:"modeIcon",style:({
        width:
          (item.posWidth / 6 > item.posHeight - 10
            ? item.posHeight.scale
            : (item.posWidth / 12) * _vm.scale) + 'vw',
      }),attrs:{"src":require("@/assets/images/model-icon.png")}}),_c('div',{staticClass:"d-play-bg",on:{"click":function($event){$event.stopPropagation();return _vm.modelPlay(item, 1)}}},[_c('div',{staticClass:"img",style:({
          width:
            (item.posWidth / 6 > item.posHeight - 10
              ? item.posHeight * _vm.scale
              : (item.posWidth / 6) * _vm.scale) + 'vw',
          height:
            (item.posWidth / 6 > item.posHeight - 10
              ? item.posHeight * _vm.scale
              : (item.posWidth / 6) * _vm.scale) + 'vw',
        })})]),_c('img',{style:({ width: '100%', height: '100%' }),attrs:{"src":_vm.aliOsUrl(item.coverImage) +
        '?v=' +
        new Date().getTime() +
        Math.random()}})])}),_vm._l((_vm.data.shapeList),function(item,index){return _c('div',{key:'shapeTool-sty'+item.id+index,staticClass:"shapeTool-sty",class:{ active: item.selected },style:({
      width: item.posWidth * _vm.scale + 'vw',
      height: item.posHeight * _vm.scale + 'vw',
      position: 'absolute',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: 'rotate(' + item.rotation + 'deg)',
    })},[_c('div',{staticClass:"svg-wrap ql-editor",staticStyle:{"width":"100%","height":"100%"},domProps:{"innerHTML":_vm._s(item.data)}})])}),_vm._l((_vm.data.uiVideoVOs),function(item,index){return _c('div',{key:'videoTool-sty'+item.id+index,staticClass:"videoTool-sty",class:{ active: item.selected },style:({
      width: item.posWidth * _vm.scale + 'vw',
      height: item.posHeight * _vm.scale + 'vw',
      position: 'absolute',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: 'rotate(' + item.rotation + 'deg)',
    })},[_c('img',{style:({ width: '100%', height: '100%' }),attrs:{"src":_vm.aliOsUrl(item.coverImage) +
        '?v=' +
        new Date().getTime() +
        Math.random()}}),_c('div',{staticClass:"d-play-bg",on:{"mousedown":function($event){$event.stopPropagation();},"click":function($event){$event.stopPropagation();return _vm.modelPlay(item, 2)}}},[_c('img',{style:({
            width:
              (item.posWidth / 7 > item.posHeight - 10
                ? item.posHeight * _vm.scale
                : (item.posWidth / 7) * _vm.scale) + 'vw',
          }),attrs:{"src":require("@/assets/images/3d_play_btn.png")}})])])}),_vm._l((_vm.data.uiAudioVOs),function(item,index){return _c('div',{key:'audioTool-sty'+item.id+index,staticClass:"audioTool-sty",class:{ active: item.selected, locked: item.isLock },style:({
      width: 220 * _vm.scale + 'vw',
      height: 70 * _vm.scale + 'vw',
      position: 'absolute',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: 'rotate(' + item.rotation + 'deg)',
    })},[_c('div',{staticClass:"audio-sty-div",style:({
        width: 200 * _vm.scale + 'vw',
        height: 70 * _vm.scale + 'vw',
        lineHeight: 60 * _vm.scale + 'vw',
        padding: 5 * _vm.scale + 'vw',
        paddingLeft: 15 * _vm.scale + 'vw',
        fontSize: 16 * _vm.scale + 'vw',
      })},[_c('img',{style:({ marginRight: 8 * _vm.scale + 'vw' }),attrs:{"src":require("@/assets/images/shape-icon.png")},on:{"click":function($event){$event.stopPropagation();return _vm.modelPlay(item, 3)}}}),_c('span',[_vm._v(_vm._s(item.src.substring(item.src.lastIndexOf("/") + 1, item.src.length)))])])])}),_vm._l((_vm.data.tableList),function(item,index){return _c('div',{key:'tableTool-sty'+item.id+index,staticClass:"tableTool-sty",class:{ active: item.selected },style:({
      width: item.posWidth * _vm.scale + 'vw',
      height: item.posHeight * _vm.scale + 'vw',
      position: 'absolute',
      background: '#fff',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: !_vm.noRotation
        ? 'rotate(' + item.rotation + 'deg)'
        : 'rotate(0deg)',
    }),attrs:{"id":'tab' + _vm.indexP + ',' + _vm.ind + ',' + index}},[_c('table',{style:({
        width: item.posWidth + 'vw',
        height: item.posHeight + 'vw',
        transform: 'scale(' + _vm.scale + ')',
      }),attrs:{"cellpadding":"0","cellspacing":"0","border":"0"}},_vm._l((item.dataList),function(its,trindex){return _c('tr',{key:trindex,attrs:{"nowrap":"nowrap"}},_vm._l((its),function(td,tdindex){return _c('td',{key:tdindex,style:({
            width: td.width + 'vw',
            height: td.height + 'vw',
            borderStyle: td.borderStyle,
            borderTopWidth: td.borderTopWidth,
            borderTopColor: td.borderTopColor,
            borderRightWidth: td.borderRightWidth,
            borderRightColor: td.borderRightColor,
            borderBottomWidth: td.borderBottomWidth,
            borderBottomColor: td.borderBottomColor,
            borderLeftWidth: td.borderLeftWidth,
            borderLeftColor: td.borderLeftColor,
            overflow: 'hidden',
          })},[_c('div',{staticClass:"con con-el ql-editor",style:({
              cursor: !item.edit ? 'unset' : '',
              'font-size': td.fontSize + 'vw',
              color: td.fontColor,
              'font-weight': td.bold,
              'text-align': td.align,
              'text-decoration': td.direction,
              'font-family': td.font,
            }),domProps:{"innerHTML":_vm._s(_vm.ToCDB(td.content))}})])}),0)}),0)])}),_vm._l((_vm.data.chartList),function(item,index){return _c('div',{key:'chartTool-sty'+item.id+index,staticClass:"chartTool-sty",class:{ active: item.selected },style:({
      width: item.posWidth * _vm.scale + 'vw',
      height: item.posHeight * _vm.scale + 'vw',
      position: 'absolute',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: 'rotate(' + item.rotation + 'deg)',
    }),attrs:{"id":'chart' + _vm.indexP + ',' + _vm.ind + ',' + index}},[(item.dataList)?void 0:_vm._e()],2)}),_vm._l((_vm.data.detailPageList),function(item,index){return _c('div',{key:'detailPageTool-sty'+item.id+index,staticClass:"detailPageTool-sty",style:({
      width: 200 * _vm.scale + 'vw',
      height: 200 * _vm.scale + 'vw',
      position: 'absolute',
      left: item.posLeft * _vm.scale + 'vw',
      top: item.posTop * _vm.scale + 'vw',
      'z-index': item.zIndex,
      transform: 'rotate(' + item.rotation + 'deg)',
    })},[_c('img',{staticClass:"animate__animated animate__pulse animate__infinite animate__faster detail-icon",style:({ width: '26%', height: '26%' }),attrs:{"src":require("@/assets/images/icon_ts_bg.png")},on:{"click":function($event){$event.stopPropagation();return _vm.modelPlay(item, 4)}}}),_c('img',{staticClass:"rotate detail-icon",style:({ width: '19%', height: '19%' }),attrs:{"src":require("@/assets/images/icon_ts_xian.png")},on:{"click":function($event){$event.stopPropagation();return _vm.modelPlay(item, 4)}}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.hasOwnProperty('imageId')),expression:"item.hasOwnProperty('imageId')"}],staticClass:"detail-icon",style:({ width: '14%', height: '14%' }),attrs:{"src":require("@/assets/images/icon_ts_images.png")},on:{"click":function($event){$event.stopPropagation();return _vm.modelPlay(item, 4)}}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.hasOwnProperty('modelId')),expression:"item.hasOwnProperty('modelId')"}],staticClass:"detail-icon",style:({ width: '14%', height: '14%' }),attrs:{"src":require("@/assets/images/icon_ts_model.png")},on:{"click":function($event){$event.stopPropagation();return _vm.modelPlay(item, 4)}}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.hasOwnProperty('videoId')),expression:"item.hasOwnProperty('videoId')"}],staticClass:"detail-icon",style:({ width: '14%', height: '14%' }),attrs:{"src":require("@/assets/images/icon_ts_mp4.png")},on:{"click":function($event){$event.stopPropagation();return _vm.modelPlay(item, 4)}}})])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }